import * as Constants from "../constants";

/**
 * API client for the tenant's integration credential record.
 *
 *   GET /credential -> returns the customer's credential document, including
 *                      `sis_sync_settings` (per-integration settings blocks).
 *
 * Mirrors the legacy html/js/v2/credential.controller.js (getCredential), but
 * rejects on network / HTTP errors instead of swallowing them, so callers can
 * surface a message rather than silently rendering an empty state.
 */

async function parse(response) {
  const text = await response.text().catch(() => "");
  let body = {};
  if (text) {
    try {
      body = JSON.parse(text);
    } catch (e) {
      if (!response.ok) throw new Error(`Request failed (${response.status})`);
      body = {};
    }
  }
  if (!response.ok) {
    const detail = body.userMessage || body.message || body.error;
    throw new Error(
      typeof detail === "string" && detail
        ? detail
        : `Request failed (${response.status})`
    );
  }
  return body;
}

/** Fetch the credential record. Resolves to `returnData`; throws on failure. */
export async function getCredential() {
  const headers = Object.assign({}, Constants.commonHeaders);
  const response = await fetch(
    `${Constants.baseURL}${Constants.credentialAPI}`,
    {
      headers,
      crossDomain: true,
    }
  );
  const body = await parse(response);
  return body.returnData;
}
